/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ecommerce_Amazon_Tools_Tlm_1Inputs */

const en_svc_ecommerce_amazon_tools_tlm_1 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sync`)
};

const ar_svc_ecommerce_amazon_tools_tlm_1 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المزامنة`)
};

const bn_svc_ecommerce_amazon_tools_tlm_1 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সিঙ্ক`)
};

const de_svc_ecommerce_amazon_tools_tlm_1 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync`)
};

const es_svc_ecommerce_amazon_tools_tlm_1 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronización`)
};

const fr_svc_ecommerce_amazon_tools_tlm_1 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronisation`)
};

const pt_svc_ecommerce_amazon_tools_tlm_1 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronização`)
};

const zh_svc_ecommerce_amazon_tools_tlm_1 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同步`)
};

const tr_svc_ecommerce_amazon_tools_tlm_1 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senkron`)
};

const ru_svc_ecommerce_amazon_tools_tlm_1 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Синхронизация`)
};

const pl_svc_ecommerce_amazon_tools_tlm_1 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronizacja`)
};

/**
* | output |
* | --- |
* | "sync" |
*
* @param {Svc_Ecommerce_Amazon_Tools_Tlm_1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ecommerce_amazon_tools_tlm_1 = /** @type {((inputs?: Svc_Ecommerce_Amazon_Tools_Tlm_1Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ecommerce_Amazon_Tools_Tlm_1Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ecommerce_amazon_tools_tlm_1(inputs)
	if (locale === "bn") return bn_svc_ecommerce_amazon_tools_tlm_1(inputs)
	if (locale === "de") return de_svc_ecommerce_amazon_tools_tlm_1(inputs)
	if (locale === "es") return es_svc_ecommerce_amazon_tools_tlm_1(inputs)
	if (locale === "fr") return fr_svc_ecommerce_amazon_tools_tlm_1(inputs)
	if (locale === "pt") return pt_svc_ecommerce_amazon_tools_tlm_1(inputs)
	if (locale === "zh") return zh_svc_ecommerce_amazon_tools_tlm_1(inputs)
	if (locale === "tr") return tr_svc_ecommerce_amazon_tools_tlm_1(inputs)
	if (locale === "ru") return ru_svc_ecommerce_amazon_tools_tlm_1(inputs)
	if (locale === "pl") return pl_svc_ecommerce_amazon_tools_tlm_1(inputs)
	return en_svc_ecommerce_amazon_tools_tlm_1(inputs)
});
export { svc_ecommerce_amazon_tools_tlm_1 as "svc_ecommerce-amazon-tools_tlm_1" }